module.exports = __webpack_public_path__ + "static/media/3.e606c26e.png";